// ABOUTME: Step 1 of approve Bol replenishment - choose shipping type.
// ABOUTME: User picks "self" or "pickup", value is stored in progression data as `type`.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import StoreMallDirectoryOutlinedIcon from "@mui/icons-material/StoreMallDirectoryOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

import ProgressionTab from "../../../../theme/ProgressionBuilder/ProgressionTab";
import Text from "../../../../theme/text/Text";
import { tokens } from "../../../../../theme";

const TypeCard = ({ selected, onClick, icon, title, description, colors, theme }) => {
    const accent = theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400];
    const bgUnselected = theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100];
    const bgSelected = theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100];

    return (
        <Box
            onClick={onClick}
            sx={{
                position: "relative",
                cursor: "pointer",
                flex: 1,
                minWidth: 0,
                borderRadius: 4,
                padding: 2.5,
                background: selected ? bgSelected : bgUnselected,
                border: `2px solid ${selected ? accent : "transparent"}`,
                transition: "all 200ms ease",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: theme.palette.mode === "dark"
                        ? "0 4px 12px rgba(0,0,0,.4)"
                        : "0 4px 12px rgba(46,65,95,.12)",
                },
            }}
        >
            {selected && (
                <Box sx={{ position: "absolute", top: 10, right: 10, color: accent, display: "flex" }}>
                    <CheckCircleRoundedIcon fontSize="small" />
                </Box>
            )}
            <Box
                sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: selected ? accent : (theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]),
                    color: selected ? "#fff" : accent,
                    transition: "all 200ms ease",
                    mb: 0.5,
                }}
            >
                {icon}
            </Box>
            <Text bold>{title}</Text>
            <Box sx={{ opacity: 0.75 }}>
                <Text light>{description}</Text>
            </Box>
        </Box>
    );
};

const Content = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const selected = props.data?.type;

    const select = (type) => {
        props.handleDataUpdate({ type });
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Box sx={{ opacity: 0.7 }}>
                <Text light>{t("choose_replenishment_type_explanation")}</Text>
            </Box>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <TypeCard
                    selected={selected === "self"}
                    onClick={() => select("self")}
                    icon={<LocalShippingOutlinedIcon />}
                    title={t("replenishment_type_self")}
                    description={t("replenishment_type_self_description")}
                    colors={colors}
                    theme={theme}
                />
                <TypeCard
                    selected={selected === "pickup"}
                    onClick={() => select("pickup")}
                    icon={<StoreMallDirectoryOutlinedIcon />}
                    title={t("replenishment_type_pickup")}
                    description={t("replenishment_type_pickup_description")}
                    colors={colors}
                    theme={theme}
                />
            </Box>
        </Box>
    );
};

const SelectType = (props) => {
    const { t } = useTranslation();
    const data = useSelector((state) => state.progressiontabs.data);

    return (
        <ProgressionTab
            tabId="tabSelectType"
            step={1}
            maxSteps={2}
            subtitle={t("choose_replenishment_type")}
            nextTab="tabPickDate"
            nextDisabled={!data?.type}
            updateData={{ bolReplenishmentId: props.bolReplenishmentId }}
        >
            <Content />
        </ProgressionTab>
    );
};

export default SelectType;
